import {
  CreateUser,
  DeleteUser,
  UpdateUser,
  getRoles,
  getUser,
  getUsers,
} from "@/api/users/users-services";

const normalizeRolesForApi = (roles, rolOptions) => {
  if (!Array.isArray(roles)) return roles;

  const options = Array.isArray(rolOptions) ? rolOptions : [];
  const normalized = roles
    .map((role) => {
      if (typeof role === "number" && Number.isFinite(role)) return role;

      if (typeof role === "string") {
        const trimmed = role.trim();
        if (!trimmed) return undefined;

        const maybeId = Number(trimmed);
        if (!Number.isNaN(maybeId) && Number.isFinite(maybeId)) {
          return maybeId;
        }

        const foundByName = options.find(
          (opt) => String(opt?.name ?? "").toLowerCase() === trimmed.toLowerCase(),
        );
        return typeof foundByName?.id === "number" ? foundByName.id : undefined;
      }

      if (role && typeof role === "object") {
        if (typeof role.id === "number" && Number.isFinite(role.id)) return role.id;
        if (typeof role.name === "string") {
          const foundByName = options.find(
            (opt) =>
              String(opt?.name ?? "").toLowerCase() === role.name.toLowerCase(),
          );
          return typeof foundByName?.id === "number" ? foundByName.id : undefined;
        }
      }

      return undefined;
    })
    .filter((role) => typeof role === "number" && Number.isFinite(role));

  const rolesAreAlreadyIds = roles.every(
    (role) => typeof role === "number" && Number.isFinite(role),
  );
  if (rolesAreAlreadyIds) return roles;

  return normalized;
};

const normalizeSendNotificationForApi = (sendNotification) =>
  sendNotification ? 1 : 0;

export const usersSlice = (set, get) => ({
  loggedInEmailUser: "",
  loggedInUser: {},
  users: [],
  rolOptions: [],
  updateModal: false,
  userToUpdateData: {},

  setLoggedInEmailUser: (email) => {
    set({ loggedInEmailUser: email });
  },

  setLoggedInUser: (user) => {
    set({ loggedInUser: user });
  },

  updateLoggedInUser: async (id, userData) => {
    const normalizedUserData = {
      ...userData,
      roles: normalizeRolesForApi(userData?.roles, get().rolOptions),
    };

    await UpdateUser(id, normalizedUserData);
    const updatedUser = await getUser(id);
    set({ loggedInUser: updatedUser });
  },

  getUsers: async () => {
    const data = await getUsers();
    set({ users: data });
    return data;
  },

  getRoles: async () => {
    const data = await getRoles();
    set({ rolOptions: data });
    return data;
  },

  createUser: async (userData) => {
    const normalizedUserData = {
      ...userData,
      roles: normalizeRolesForApi(userData?.roles, get().rolOptions),
      sendNotification: normalizeSendNotificationForApi(
        userData?.sendNotification,
      ),
    };
    try {
      await CreateUser(normalizedUserData);
      get().getUsers();
    } catch (error) {
      throw error;
    }
  },

  deleteUser: async (id) => {
    await DeleteUser(id);
    get().getUsers();
  },

  setUpdateModal: (value) => {
    set((state) => ({
      updateModal: value,
      userToUpdateData: value ? state.userToUpdateData : {},
    }));
  },

  getUserToUpdateData: async (id) => {
    const data = await getUser(id);
    set({ userToUpdateData: data });
    return data;
  },

  updateUser: async (id, userData) => {
    const normalizedUserData = {
      ...userData,
      roles: normalizeRolesForApi(userData?.roles, get().rolOptions),
      sendNotification: normalizeSendNotificationForApi(
        userData?.sendNotification,
      ),
    };
    await UpdateUser(id, normalizedUserData);
    get().getUsers();
  },
});
